import { render } from "./preloader_logo.vue?vue&type=template&id=20a97b83&scoped=true"
import script from "./preloader_logo.vue?vue&type=script&lang=js"
export * from "./preloader_logo.vue?vue&type=script&lang=js"

import "./preloader_logo.vue?vue&type=style&index=0&id=20a97b83&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a97b83"]])

export default __exports__